import { render, staticRenderFns } from "./refundwb.vue?vue&type=template&id=0c89a790&scoped=true&"
import script from "./refundwb.vue?vue&type=script&lang=js&"
export * from "./refundwb.vue?vue&type=script&lang=js&"
import style0 from "./refundwb.vue?vue&type=style&index=0&id=0c89a790&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c89a790",
  null
  
)

export default component.exports